<template>
  <div v-html="$t('additional-info')"></div>
</template>
